import { configureEcho, echo } from '@laravel/echo-vue';

interface PusherConnectorLike {
    pusher?: { connection: { state: string; connect(): void } };
}

export function configureBroadcasting(): void {
    const key = import.meta.env.VITE_PUSHER_APP_KEY;

    if (!key) {
        return;
    }

    const scheme = import.meta.env.VITE_PUSHER_SCHEME ?? 'https';
    const port = Number(import.meta.env.VITE_PUSHER_PORT ?? (scheme === 'https' ? 443 : 80));

    configureEcho({
        broadcaster: 'pusher',
        key,
        cluster: 'mt1',
        wsHost: import.meta.env.VITE_PUSHER_HOST,
        wsPort: port,
        wssPort: port,
        forceTLS: scheme === 'https',
        enabledTransports: ['ws', 'wss'],
        activityTimeout: 30000,
        pongTimeout: 10000,
    });

    document.addEventListener('visibilitychange', () => {
        const connection = (echo().connector as PusherConnectorLike).pusher?.connection;

        if (document.visibilityState === 'visible' && connection && connection.state !== 'connected') {
            connection.connect();
        }
    });
}
